import React from "react";

/**
 * Legends "+" mark — the rotated cross identity SVG.
 * Pass `color` (default: brand blue) and `size` like a lucide icon.
 */
export default function LegendsMark({ size = 16, color = "#0060A7", className = "", style = {}, ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 60.56 60.56"
            width={size}
            height={size}
            className={className}
            style={style}
            aria-hidden
            {...props}
        >
            <g>
                <polygon fill={color} points="0 32.9 0 30.28 30.28 30.28 30.28 60.56 20.49 32.9 0 32.9" />
                <polygon fill={color} points="60.56 27.66 60.56 30.28 30.28 30.28 30.28 0 40.07 27.66 60.56 27.66" />
            </g>
        </svg>
    );
}
